import { BreadType } from 'types/bread'
import { ScheduleType } from 'types/schedule'
import { StockType } from 'types/stock'
import { Action, Dispatch } from 'redux'
import { openStockModalAction } from 'reducks/modal/actions'

const openStockModal = (bread: BreadType, schedules: ScheduleType[], stocks: StockType[], date: Date) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(openStockModalAction(bread, schedules, stocks, date))
  }
}

export default openStockModal
